window.Products.HomeDecor.TeaTowel = function() {};
window.Products.HomeDecor.TeaTowel.inherits(window.Products.HomeDecor.HomeDecor);
window.Products.HomeDecor.TeaTowel.id = 94;
window.Products.HomeDecor.TeaTowel.slug = 'tea-towel';
window.Products.HomeDecor.TeaTowel.has_3d = true;
window.Products.HomeDecor.TeaTowel.use_glb = true;
window.Products.HomeDecor.TeaTowel.dpi = 150;

window.Products.HomeDecor.TeaTowel.prototype.set3dProperties = function(modelViewer) {
	var me = this;

	modelViewer.setFixedView('front');

	me.loadEnvMap(function(){
		for(var i = 0; i < modelViewer.object.children.length; i++){
			if(!modelViewer.object.children[i].material) continue;
			modelViewer.object.children[i].material.aoMapIntensity = 1;
			modelViewer.object.children[i].material.envMap = me.envMap;
			modelViewer.object.children[i].material.envMap.mapping = THREE.EquirectangularReflectionMapping;
			modelViewer.object.children[i].material.needsUpdate = true;
			modelViewer.object.children[i].material.envMap.needsUpdate = true;
		}

		modelViewer.object.children[1].material.aoMapIntensity = 1.5;
		modelViewer.object.children[0].material.opacity = 0.9;
		modelViewer.object.children[0].material.transparent= true;

		me.updateThreeTexture(modelViewer);
	});
};

window.Products.HomeDecor.TeaTowel.prototype.setThreeControls = function(controls) {
	controls.minDistance = 1.3;
	controls.maxDistance = 2.0;
};

window.Products.HomeDecor.TeaTowel.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[2].material.map = modelViewer.texture;
	modelViewer.object.children[2].material.map.flipY = false;
	modelViewer.object.children[2].material.needsUpdate = true;
};